import { useAppSelector } from '@/redux/hooks';
import { selectBaseTerritoryGroupings } from '@/redux/selectors/constantsSelectors';

const findTerritoryByLabel = (territoryGroupings: any, value: string) => {
  if (value === 'pl') return 'Poland';
  if (value === 'nl') return 'Netherlands';
  for (const groupingKey of Object.keys(territoryGroupings)) {
    const grouping = territoryGroupings[groupingKey];
    const matchedTerritory = grouping.find((territory: any) => territory.value === value);
    if (matchedTerritory) {
      return matchedTerritory.label;
    }
  }
  return null;
};

const AvailTerritory = ({ territory }: { territory: string }) => {
  const territoryGroups = useAppSelector(selectBaseTerritoryGroupings);
  const territoryLabel = findTerritoryByLabel(territoryGroups, territory);
  return territoryLabel || territory;
};

export default AvailTerritory;
